import React from 'react'

const ModelToProviderMapping = {
  gpt: 'OpenAI',
  anthropic: 'Anthropic',
  gemini: 'Google',
  grok: 'xAI',
  openrouter: 'OpenRouter'
}

const ErrorMessages = {
  openai_organisation_verification: {
    gpt: (
      <div>
        Organization verification required.{' '}
        <a href="https://platform.openai.com/settings/organization/general" target="_blank" rel="noopener noreferrer" className="underline">
          Verify on OpenAI
        </a>
        {' '}(takes up to 15 min)
      </div>
    )
  },
  auth_error: (provider) => `${ModelToProviderMapping[provider]} authentication failed. Check your API key, permissions, or rate limits.`,
  internal_crash: () => "Our bad! Something broke on our end. We're on it.",
  provider_unavailable: (provider) => `${ModelToProviderMapping[provider] || 'The provider'} is temporarily unavailable. Please try again shortly.`,
  provider_rate_limited: (provider) => `${ModelToProviderMapping[provider] || 'The provider'} is rate-limited. Please wait a moment and try again.`,
  insufficient_balance: (provider) => `Insufficient balance for ${ModelToProviderMapping[provider] || 'the provider'}. Please check your API key or billing.`,
}

const createErrorMessage = (provider, type) => {
  const msg = ErrorMessages[type];
  const fallbackMsg = `Something unexpected happened with ${ModelToProviderMapping[provider]}. Please try again.`

  if (!msg) {
    return fallbackMsg
  } else if (typeof msg === 'function') {
    return msg(provider)
  } else if (typeof msg !== 'object' || React.isValidElement(msg)) {
    return msg
  }

  const providerMsg = msg[provider] || fallbackMsg

  if (typeof providerMsg === 'function') {
    return providerMsg(provider)
  } 
  return providerMsg
}

export const ErrorTypes = {
  openai_organisation_verification: "openai_organisation_verification",
  auth_error: "auth_error",
  external_crash: "external_crash",
  internal_crash: "internal_crash",
  provider_unavailable: "provider_unavailable",
  provider_rate_limited: "provider_rate_limited",
  insufficient_balance: "insufficient_balance",
}

export default class LlmProcessingError extends Error {
  constructor({ type, provider, message, retry }) {
    const msg = message || createErrorMessage(provider, type)

    super(msg);

    this.name = "LlmProcessingError";
    this.renderMsg = msg;
    this.errorType = type;
    this.provider = provider;
    this.retry = retry;

    // Maintains proper tack trace for where error was thrown
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LlmProcessingError)
    }
  }
}
